import { Ripple } from 'primereact/ripple';

export const PaginationButton = ({
  onClick,
  icon,
  disabled,
}: {
  onClick: () => void;
  icon: string;
  disabled?: boolean;
}) => (
  <button
    className="hover:bg-zinc-900 w-10 h-10 rounded-full disabled:opacity-50"
    onClick={onClick}
    disabled={disabled}
  >
    <span className={`pi ${icon} text-white`} />
    <Ripple />
  </button>
);
